var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',{staticClass:"dataset-hashes"},[_c('ul',{staticClass:"dataset-hashes-list"},_vm._l((_vm.hashes),function(hash,index){return _c(_setup.DatasetHash,{key:index,attrs:{"hash":hash}})}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }